<div class="container fixed-bottom" style="z-index: 1080;">
    <div *ngFor="let alert of alerts">
        <div class="alert {{ alert.class }} alert-dismissible" role="alert">
            <div [innerHTML]="alert.content"></div>
            <button type="button" class="btn-close" (click)="dismissAlert(alert)"></button>
        </div>
    </div>
</div>